<template>
  <!-- <Container> -->
    <section class="text-center">
      <!-- <img src="./../assets/img/icons/rakete2.svg" class="mx-auto h-12" alt=""> -->
      <img src="./../assets/img/icons/leuchtturm.svg" class="mx-auto" alt="">
      <!-- <div class="h1">Unsere Lieblingskunden</div> -->
      <div class="h1">Über uns</div>
      <p class="w-full sm:max-w-4xl mx-auto text-left sm:text-center">Wir sind ein Zusammenschluss leidenschaftlicher Softwareentwickler. Wir verstehen uns als Techies im Herzen, die gemeinsam etwas bewegen. Unser Mott: Speedboot statt Riesentanker: Ein Auszug unserer Lieblingsprojekte, bei denen wir glücklich sind, den Mittelstand bei ihrer Digitalisierung unterstützt zu haben.</p>
      <!-- <p class="w-full md:max-w-3xl mx-auto text-left sm:text-center">Speedboot statt Riesentanker: Ein Auszug unserer Lieblingsprojekte, bei denen wir glücklich sind, den Mittelstand bei ihrer Digitalisierung unterstützt zu haben.</p> -->
      <!-- , indem sie nun effektiv und agil wie ein Speedboot sind -->
      <div class="md:max-w-5xl mx-auto">
        <div class="justify-items-center robots-nocontent sm:mt-16 mx-4 sm:mx-0 lg:mb-24 md:mx-16 lg:mx-48 xl:mx-0 scale-105
        grid grid-cols-3 md:grid-cols-4 xl:grid-cols-5
        gap-x-6 sm:gap-x-12
        gap-y-8 sm:gap-y-16 md:gap-y-8"
        id="refContainer">
          <img src="./../assets/img/logos/weinsmann.svg" alt="Weinsmann" class="-top-4 relative" />
          <img src="./../assets/img/logos/HannoverRe.svg" alt="Hannover Rück" />
          <!-- <img src="./../assets/img/logos/athlon.png" alt="Athlon" class="relative" /> -->
          <img src="./../assets/img/logos/tesla.png" alt="Tesla" class="top-[1px] relative" />
          <img src="./../assets/img/logos/eckd.png" alt="ECKD - Dienstleistungen für Kirche & Wohlfahrt" class="top-[2px] left-4 relative" />
          <img src="./../assets/img/logos/trumpf.webp" alt="Trumpf" class="top-[1px] w-[90%] relative" />

          <img src="./../assets/img/logos/mfg.png" alt="MfG" class="-top-2 relative h-12" />
          <img src="./../assets/img/logos/stroeer.png" alt="Ströer" class="top-[1px] w-[90%] left-1 relative" />
          <img src="./../assets/img/logos/weischer.jpg" alt="Weischer Media" class="" />
          <!-- <div></div>
          <div></div> -->
          <img src="./../assets/img/logos/brandstifter.svg" alt="Brandstifter" class="top-[1px] relative" />
          <img src="./../assets/img/logos/fernsehlotterie.jpg" alt="Deutsche Fernsehlotterie" class="top-[1px] relative" />
        </div>
      </div>
      
      <div class="h1">Partner</div>
      <div class="mt-16 robots-nocontent" id="partnerContainer">
        <div class="inline-block"><a href="https://www.digitalcluster.hamburg/" target="_blank"><img src="./../assets/img/logos/hhAtWork.webp" alt="Hamburg @ work" class="h-12" /></a></div>
        <div class="inline-block"><a href="https://softwareallianz.de/" target="_blank"><img src="./../assets/img/logos/swad.webp" alt="Softwareallianz Deutschland" class="h-10 ml-8" /></a></div>
        <div class="inline-block"><a href="https://12min.me/" target="_blank"><img src="./../assets/img/logos/12minme.png" alt="12min.me" class="h-[2.75rem] ml-8" /></a></div>
        <div class="inline-block"><a href="https://www.ergonweb.de/" target="_blank"><img src="./../assets/img/logos/ergon.png" alt="Ergon Datenprojekte" class="h-[2.75rem] ml-8" /></a></div>
        <div class="inline-block -top-[10px] relative"><a href="https://silpion.de/" target="_blank"><img src="./../assets/img/logos/silpion.png" alt="Silpion" class="h-6 ml-8" /></a></div>
      </div>
    </section>
  <!-- </Container> -->
</template>

<script>
// import Container from './../views/Container.vue'

export default {
  name: 'References',
  components: {
    // Container
  },
  methods: {
    onClickCta() {
      this.$emit('clicked', 'Projekt starten')
    }
  }
}
</script>

<style scoped>
#partnerContainer > *,
#refContainer > * {
  max-height: 55px;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  transition: all 0.2s;
  opacity: 0.7;
}
  #partnerContainer > *:hover,
  #refContainer > *:hover {
    -webkit-filter: grayscale(0%);
    filter: grayscale(0%);
    opacity: 1;
    transform: scale(1.15);
  }
</style>